import React, {useEffect, useRef, useState} from "react";
import SimpleLineIcon from "react-simple-line-icons";
import "./EventeDetail.scss";
import 'swiper/swiper-bundle.min.css';
import Swiper from "swiper";

import SwiperId from 'react-id-swiper';
import {useHistory, useLocation} from "react-router-dom";
import {Nav,TextBreak} from "../../Components";
import {EventDetailData} from "./EventDetailServices";



function EventDetail() {


    //hooks
    const history = useHistory();
    const swiper = useRef(null);
    const location = useLocation();

    //states
    const [event,setEvent] = useState(null);
    const [coordinates,setCoordinates] = useState(null);


    const params = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    }

    // DualSliderDesktop ----------------------------------------------
    const Loop = ()=>{
        setInterval(()=>{
            swiper.current.slideNext();
        },2000)
    }

    useEffect(()=>{
        if(location.state && location.state.event){
            setEvent(location.state.event);
            getEvent(location.state.event)
        }

        swiper.current=new Swiper('.swiper-containera',{
            loop:true,
            autoplay: {
                delay: 5000,
            },
        })
        //Loop();
    },[])


    const getEvent = async(event) => {
        let res = await EventDetailData(event.uid);
        // console.log(res.data.body)
        setEvent(res.data);
        if(res.data.merchant && res.data.merchant.geometry){
            // console.log("Console : ",res.data)
            setCoordinates({
                lng:res.data.merchant.geometry.coordinates[0],
                lat:res.data.merchant.geometry.coordinates[1]
            })
        }
    }

    const mapsSelector = () =>{
        if(coordinates){
            if /* if we're on iOS, open in Apple Maps */
            ((navigator.platform.indexOf("iPhone") != -1) ||
                (navigator.platform.indexOf("iPad") != -1) ||
                (navigator.platform.indexOf("iPod") != -1))

                window.open("maps://maps.google.com/maps?daddr="+coordinates.lat+","+coordinates.lng+"&amp;ll=");
            else /* else use Google */
                window.open("https://maps.google.com/maps?daddr="+coordinates.lat+","+coordinates.lng+"&amp;ll=");
        }
    }


    return(
        <div className="page" >
            <div className="storeDetail-container">


                {/*Header*/}
                <div className="customer-header">
                    <span>{event && event.title}</span>
                    <i className="fa fa-arrow-right back_btn" onClick={()=>history.goBack()}></i>
                </div>




                {/*DualSliderDesktop*/}
                <div className="storeDetail-slider">
                    {event?<div className="swiper-containera swiper1">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide"><img src={event.image || event.cover } /></div>
                        </div>
                    </div>:null}
                </div>

                {/*Info*/}
                <div className="storeDetail-info">
                    {event && event.merchant?<div className="storeDetail-info-name">
                        <span className="storeDetail-info-name-title">{event.merchant && event.merchant.name}</span>
                        <span className="storeDetail-info-name-point">{event.merchant.subtitle}</span>
                    </div>:null}
                    <div className="storeDetail-info-logo">
                        {event && event.merchant ?<img src={event.merchant.thumbnail || event.merchant.image || event.merchant.cover} alt=""/>:null}
                    </div>
                </div>



                {/*About*/}
                <div className="storeDetail-about">
                    <div className="storeDetail-about-titre">
                        <span>{event?event.title:""}</span>
                    </div>

                    <div className="storeDetail-about-body">
                        {/*<span>{event && event.body}</span>*/}
                        {event && event.body?<TextBreak text={event.body}/>:null}
                    </div>
                </div>


                {/*Actions*/}
                <div className="storeDetail-actions" style={{marginBottom:70}}>
                    <div className="storeDetail-actions-item-back" onClick={()=>{
                        if(event.merchant && event.merchant.phone){
                            document.location.href="tel:"+event.merchant.phone;
                        }else {
                            //document.location.href="tel:"+'';
                        }
                    }}>
                        <img src="/svg//phone.svg" alt=""/>
                        <span>تماس</span>
                    </div>
                    <div className="storeDetail-actions-item-back" onClick={()=>mapsSelector()}>
                        <img src="/svg//direction.svg" alt=""/>
                        <span>مسیر یابی</span>
                    </div>
                    <div className="storeDetail-actions-item-back" onClick={
                        ()=>{
                            history.push(`/chat/${event.merchant.topic}`,{merchant:event.merchant})
                        }
                    }>
                        <img src="/svg//chat.png" alt=""/>
                        <span>چت</span>
                    </div>
                </div>
                <br/>
                <Nav/>
            </div>
        </div>
    )
}

export {EventDetail};
